import React, {useEffect, useState} from "react";
import MarkDraft from "./MarkDraft";

export function CellWithIcon(props) {
  const useProgressiveImage = src => {
    const [sourceLoaded, setSourceLoaded] = useState(null)

    useEffect(() => {
      const img = new Image()
      img.src = src
      img.onload = () => setSourceLoaded(src)
    }, [src])

    return sourceLoaded
  }
  return <div
    className={props.cls + " Cell Animated"}
    onClick={props.link ? () => window.open(props.link) : undefined}
    style={{backgroundImage: `url(${useProgressiveImage(props.background, props.icon)})`}}
  >
    <div className="Cell-content">
      <p>{props.text}</p>
    </div>
    {props.draft ? <MarkDraft/> : undefined}
  </div>;
}

export default CellWithIcon;
